// extracted by mini-css-extract-plugin
module.exports = {"bellyMenu":"BellyMenu_bellyMenu__455fe","item":"BellyMenu_item__1-TG4","selected":"BellyMenu_selected__3RmpO"};